export default "__VITE_ASSET__B755zz$D__"